module.exports = "/static/assets/8c2a390eb09d64bc13f4cfa3283fc33f.gif";